<template>
  <div class="block">
    <ul class="row c-justify-around c-mb-0 list-unstyled">
      <ProductBenefitsItem
        v-for="benefit in benefits"
        :key="benefit.id"
        :benefit="benefit"
      />
    </ul>
  </div>
</template>

<script setup>
import ProductBenefitsItem from '../products/ProductBenefitsItem.vue'

defineProps({
  benefits: {
    type: Array,
    required: true,
  },
})
</script>
